import findKey from 'lodash/findKey';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { MENU_ITEMS_DETAIL as entity } from 'bento-ordering/menus/constants/entities';
import bentoApi, {
  getItemByIdSelector
} from 'bento-ordering/base/reducers/bentoApi';
import { hasModifiersV2FeatureFlag } from 'helpers/featureFlags/hasModifiersV2FeatureFlag';

const apiReducer = bentoApi(entity);
export default apiReducer;

/* ==== SELECTORS ==== */

export const getMenuItemImage = state => get(state.images, '[0].url', '');

export const getMenuItem = (state, menuItemSlug) => {
  const { account, menuItemsDetail } = state;

  const foundId = findKey(menuItemsDetail.byId, value => {
    return value.slug === menuItemSlug;
  });

  const menuItem = getItemByIdSelector(menuItemsDetail, foundId);

  const isUsingModifiersV2 = hasModifiersV2FeatureFlag(
    account.beta_feature_flags
  );

  // TODO: refactor this once modifiers_v2 are fully migrated
  if (isUsingModifiersV2 && !isEmpty(menuItem)) {
    menuItem.variants = [
      {
        ...menuItem?.variants[0],
        fields: menuItem?.variants[0]?.modifier_groups
      }
    ];
  }

  return menuItem;
};

export const getMenuItemByProductId = (state, id) => {
  const menuItem = getItemByIdSelector(state, id);
  return menuItem;
};
